import styled from "styled-components";

export const Container = styled.section`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 2rem 1rem 0;
    margin-bottom: 1rem;

    .avatar-item img {
        width: 5rem;
        border-radius: 50%;
        margin-right: 2rem;
        margin-bottom: 1rem;
    }
`;